import React, { FC } from 'react'
import { MatchEventType, BonusScoreType } from 'protos'

import iconEventAssistUrl from './assets/icon_event_assist.svg'
import iconEventGoalUrl from './assets/icon_event_goal.svg'
import iconEventInDrawUrl from './assets/icon_event_in_draw.svg'
import iconEventInLeadUrl from './assets/icon_event_in_lead.svg'
import iconEventShotOnGoalUrl from './assets/icon_event_shot_on_goal.svg'
import iconEventTimeBonusUrl from './assets/icon_event_time_bonus.svg'
import iconEventYellowUrl from './assets/icon_event_yellow_card.svg'
import iconEventRedUrl from './assets/icon_event_red_card.svg'
import iconEventYellowRedUrl from './assets/icon_event_yellowred_card.svg'
import iconEventOwnGoalUrl from './assets/icon_event_own_goal.svg'
import iconEventCornerUrl from './assets/icon_event_corner.svg'
import iconEventSubUrl from './assets/icon_event_sub.svg'
import iconEventSaveUrl from './assets/icon_event_save.svg'
import iconEventPenaltyUrl from './assets/icon_event_penalty.svg'
import iconEventDefaultUrl from './assets/icon_event_default.svg'
import { BonusScoreToken, MatchEventToken } from 'lib/enumTranslations'
import { useIntl } from 'react-intl'

type Props = {
  bonus?: BonusScoreType | null
  event?: MatchEventType | null
}

const getIconUrlForScoringItem = ({ bonus, event }: Props) => {
  if (bonus !== undefined && bonus !== null) {
    switch (bonus) {
      case BonusScoreType.BS_ACTIVITY_BONUS:
        return iconEventTimeBonusUrl

      case BonusScoreType.BS_SHOT_ON_GOAL:
        return iconEventShotOnGoalUrl

      case BonusScoreType.BS_TEAM_IN_DRAW_BONUS:
        return iconEventInDrawUrl

      case BonusScoreType.BS_GOAL:
        return iconEventGoalUrl

      case BonusScoreType.BS_TEAM_IN_LEAD_BONUS:
        return iconEventInLeadUrl

      case BonusScoreType.BS_CORNER:
        return iconEventCornerUrl
    }
  }

  if (event !== undefined && event !== null) {
    switch (event) {
      case MatchEventType.ET_ASSIST:
        return iconEventAssistUrl

      case MatchEventType.ET_GOAL:
        return iconEventGoalUrl

      case MatchEventType.ET_OWN_GOAL:
        return iconEventOwnGoalUrl

      case MatchEventType.ET_YELLOW_CARD:
        return iconEventYellowUrl

      case MatchEventType.ET_RED_CARD:
        return iconEventRedUrl

      case MatchEventType.ET_YELLOW_RED_CARD:
        return iconEventYellowRedUrl

      case MatchEventType.ET_SHOT_ON_GOAL:
        return iconEventShotOnGoalUrl

      case MatchEventType.ET_CORNER:
        return iconEventCornerUrl

      case MatchEventType.ET_SUB_IN:
      case MatchEventType.ET_SUB_OUT:
        return iconEventSubUrl

      case MatchEventType.ET_SAVE:
        return iconEventSaveUrl

      case MatchEventType.ET_PENALTY_CONCEDED:
      case MatchEventType.ET_PENALTY_GOAL:
      case MatchEventType.ET_PENALTY_MISSED:
      case MatchEventType.ET_PENALTY_SAVED:
      case MatchEventType.ET_PENALTY_SHOOTOUT_GOAL:
      case MatchEventType.ET_PENALTY_SHOOTOUT_MISSED:
        return iconEventPenaltyUrl
    }
  }

  return iconEventDefaultUrl
}

const ScoreItemIcon: FC<Props> = props => {
  const { formatMessage } = useIntl()
  const labelToken = (
    (props.event && MatchEventToken(props.event)) ||
    (props.bonus && BonusScoreToken(props.bonus))
  )

  return (
    <img
      src={getIconUrlForScoringItem(props)}
      alt={labelToken ? formatMessage({ id: labelToken }) : undefined}
    />
  )
}

export default ScoreItemIcon
try {
    // @ts-ignore
    ScoreItemIcon.displayName = "ScoreItemIcon";
    // @ts-ignore
    ScoreItemIcon.__docgenInfo = { "description": "", "displayName": "ScoreItemIcon", "props": { "bonus": { "defaultValue": null, "description": "", "name": "bonus", "required": false, "type": { "name": "any" } }, "event": { "defaultValue": null, "description": "", "name": "event", "required": false, "type": { "name": "any" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/components/PlayerLayer/components/PlayerProfile/components/ScoreItemIcon/ScoreItemIcon.tsx#ScoreItemIcon"] = { docgenInfo: ScoreItemIcon.__docgenInfo, name: "ScoreItemIcon", path: "src/components/PlayerLayer/components/PlayerProfile/components/ScoreItemIcon/ScoreItemIcon.tsx#ScoreItemIcon" };
}
catch (__react_docgen_typescript_loader_error) { }